import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import AllRentProducts from "./AllRentProducts/AllRentProducts";
import FilterAll from "../FilterAll/FilterAll";
import { useDispatch, useSelector } from "react-redux";
import { getFilter } from "../../../../redux/filter/action";
import OTSSearch from "../../../Common/Search/OTSSearch";
import { useAllFilterBaseContext } from "../../../../Context/AllFilterBaseContext";
import classnames from "classnames";
import { Nav, NavItem, NavLink } from "reactstrap";
import { FilterRentalListings } from "../../../../redux/rental/action";
import { useNavigate } from "react-router-dom";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { getPostStingName } from "../../../../assests/extention/commonfunction";

export default function SearchRentProducts() {
  const {
    state,
    setSearch,
    setProposed,
    setViewed,
    setWishlist,
    setListNull,
    setRerender,
    setAllpostfiltertab,
  } = useAllFilterBaseContext();

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const dispatch = useDispatch();
  const { pageNumber } = state;
  const size = 15;

  const [activeTab, setActiveTab] = useState(
    "allpost" || state?.allpostfiltertab
  );

  const getallrental = useSelector(
    ({ rental: { getfilterdrental } }) => getfilterdrental
  );
  const getrentallist = getallrental?.response || [];

  useEffect(() => {
    dispatch(getFilter(5));
  }, []);

  useEffect(() => {
    if (state?.allpostfiltertab) {
      setActiveTab(state?.allpostfiltertab);
    } else {
      setActiveTab("allpost");
    }
  }, [state?.allpostfiltertab]);

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setAllpostfiltertab(tab);
      setRerender();

      switch (tab) {
        case "allpost":
          setListNull();
          break;
        case "recentview":
          setViewed();
          break;
        case "savepost":
          setWishlist();
          break;
        case "appliedpost":
          setProposed();
          break;
        default:
          break;
      }
    }
  };

  const data = {
    method: "GET",
    index: pageNumber,
    size: size,
    search: state?.search,
    proposed: state.proposed,
    viewed: state.viewed,
    wishlist: state.wishlist,
    filter: [
      {
        id: "51",
        title: "Category",
        filter_type: "5",
        values: state?.keywords,
      },
      {
        id: "29",
        title: "Industry",
        filter_type: "5",
        values: state?.industries,
      },
      {
        id: "54",
        title: "Sub Category",
        filter_type: "5",
        values: state?.subcategories,
      },
      {
        id: "27",
        title: "Rental Type",
        filter_type: "2",
        values: state?.sortByOptions,
      },
      {
        id: "28",
        title: "sort by",
        filter_type: "2",
        values: state?.sortByTime,
      },
      {
        id: "30",
        title: "Price range",
        min: state.minHourlyRate,
        max: state.maxHourlyRate,
        filter_type: "7",
      },
    ],
  };

  useEffect(() => {
    dispatch(FilterRentalListings(data));
  }, [state]);

  const { setOTSroute } = useRouteBaseStateContext();
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");

  return (
    <div className="project-section searchbuy">
      <div className="col-md-12 project1">
        <div className="col-md-6 mx-auto">
          <h2 className="font-42">
            Experience Excellence: Rent from Our Exclusive Collection!
          </h2>
          <OTSSearch
            state={state}
            setSearch={setSearch}
            placeholder={`Search ${getPostStingName("6")}`}
          />
        </div>
        <p>Have a product for Rent? Let’s get it listed</p>
        <button
          onClick={() => { navigate(`/${lan}/dashboard/myotsproducts`); setOTSroute('RentalProducts'); }}
          className="btn post-btn"
        >
          Add a Product
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/project/plus.svg`}
            alt=""
          />
        </button>
      </div>
      <div className="col-lg-10 mx-auto tab-sec packaged-tab">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "allpost" })}
              onClick={() => {
                toggle("allpost");
              }}
            >
              All ({getallrental?.count?.count || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "recentview" })}
              onClick={() => {
                toggle("recentview");
              }}
            >
              Recently viewed ({getallrental?.count?.viewed_count || 0})
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab == "savepost" })}
              onClick={() => {
                toggle("savepost");
              }}
            >
              Saved Products ({getallrental?.count?.wishlist_count || 0})
            </NavLink>
          </NavItem>
        </Nav>
        <div className="row">
          <div className="col-lg-3 col-md-4">
            <FilterAll />
          </div>
          <AllRentProducts activeTab={activeTab} />
        </div>
      </div>
    </div>
  );
}
